module.exports = __webpack_public_path__ + "media/media/logos/vibration-institute-13f43c3ce18cafe14986691f777ee8c0.png";